import React from 'react';
import { InstagramIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0F] border-t border-white/10 py-12" data-id="element-55">
      <div className="max-w-7xl mx-auto px-6" data-id="element-56">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-57">
          <div className="md:col-span-2" data-id="element-58">
            <h3 className="text-2xl font-black text-white mb-4" data-id="element-59">Artreal</h3>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md" data-id="element-60">
              AI-powered mockup generator for artists. Create stunning,
              realistic room scenes for your artwork in seconds.
            </p>
            <div className="flex gap-4" data-id="element-61">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-all duration-200" data-id="element-62">
                <InstagramIcon className="w-5 h-5 text-gray-400" data-id="element-63" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-all duration-200" data-id="element-64">
                <TwitterIcon className="w-5 h-5 text-gray-400" data-id="element-65" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-all duration-200" data-id="element-66">
                <MailIcon className="w-5 h-5 text-gray-400" data-id="element-67" />
              </a>
            </div>
          </div>

          <div data-id="element-68">
            <h4 className="font-bold text-white mb-4" data-id="element-69">Product</h4>
            <ul className="space-y-3" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-72">
                  Features
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-74">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-75">
            <h4 className="font-bold text-white mb-4" data-id="element-76">Legal</h4>
            <ul className="space-y-3" data-id="element-77">
              <li data-id="element-78">
                <a href="https://go.pixo.co/artreal-privacy" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-79">
                  Privacy
                </a>
              </li>
              <li data-id="element-80">
                <a href="https://go.pixo.co/artreal-terms" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-81">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-82">
          <p className="text-gray-500 text-sm" data-id="element-83">
            © 2026 Artreal. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm" data-id="element-84">
            Made with ❤️ for artists worldwide
          </p>
        </div>
      </div>
    </footer>;
}